<script setup lang="ts">
import KBtn from '@/components/btns/KBtn.vue';

export interface Props {
  icon?: string;
}
const props = withDefaults(defineProps<Props>(), {
  icon: undefined,
});
</script>

<template>
  <KBtn
    variant="text"
    :icon="props.icon"
    :class="$style.appBarBtn"
    data-testid="appBarBtn"
  />
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use 'sass:math';
@use '@/styles/colors';
@use '@/styles/variables';

.appBarBtn {
  width: 40px !important;
  height: 40px !important;
  font-size: 16px !important;

  :global {
    .v-btn__content {
      width: variables.$appBarBtnWidth !important;
      height: variables.$appBarHeight !important;
      margin-top: - math.div((variables.$appBarHeight - 40px), 2);
    }
  }
}
</style>
